'use client';

import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import useGlobalServiceViewModel from '@module/helpers/channel/globalService/useGlobalServiceViewModel';
import { aspCond } from '@module/helpers/conditions/condition';
import { cn } from '@module/lib/utils';
import { useBjInfoQuery } from '@module/queries/member/memberQueryHooks';
import useModalStore from '@module/stores/useModalStore';
import { IcoChannelNotice, IcoClose, IcoProfileBan, MissionIconWhite } from '@module/svg/icons';
import { MODAL_TYPE_PC } from '@module/types/modal/type';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import formatNumberWithComma from '@module/utils/formatNumberWithComma';
import BookmarkButton from '@pc/components/atoms/button/BookmarkButton';
import VipDecoBadge from '@pc/components/badge/VipDecoBadge';
import BaseSVG from '@pc/components/image/BaseSVG';
import BaseLottie from '@pc/components/lottie/BaseLottie';
import ModalMissionChallenge from '@pc/components/play/info/mission/modal/ModalMissionChallenge';
import { Skeleton } from '@pc/components/ui/skeleton';
import useGoPlay from '@pc/hooks/play/useGoPlay';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';
import GlobalServiceNoticeBanner from './GlobalServiceNoticeBanner';
function ChannelHeader() {
  const $ = _c(128);
  const params = useParams();
  const channelId = params?.id ? decodeURIComponent(params.id) : "";
  const {
    pushModal,
    popModal
  } = useModalStore();
  const {
    userInfo,
    isLogin,
    isPostAvailable
  } = useGetLoginInfoQuery();
  const isMyChannel = channelId === userInfo?.id;
  const [isChannelInfoOpen, setIsChannelInfoOpen] = useState(false);
  const [isMissionModalOpen, setIsMissionModalOpen] = useState(false);
  const {
    goPlay
  } = useGoPlay();
  let t0;
  if ($[0] !== channelId) {
    t0 = {
      userId: channelId,
      info: "media fanGrade adminBjNotice exchange checkEnter bookmark"
    };
    $[0] = channelId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: bjInfoData,
    refetch: refetchBjInfo
  } = useBjInfoQuery(t0);
  const {
    isAllEmptyGlobalProfileData: showGlobalNoticeBanner
  } = useGlobalServiceViewModel();
  const isBlockedService = !!bjInfoData?.bjInfo.blockService;
  const isTopRank = !!bjInfoData && bjInfoData.bjInfo.rank > 0 && bjInfoData.bjInfo.rank < 4;
  let t1;
  let t2;
  if ($[2] !== isChannelInfoOpen) {
    t1 = () => {
      const container = document.getElementById("top-nav-container");
      if (!container) {
        return;
      }
      if (isChannelInfoOpen) {
        if (!document.getElementById("top-nav-overlay-element")) {
          const overlay = document.createElement("div");
          overlay.className = "absolute -bottom-[1px] left-0 right-0 top-0 z-10 bg-black/50";
          overlay.id = "top-nav-overlay-element";
          container.appendChild(overlay);
        }
      } else {
        const existingOverlay = document.getElementById("top-nav-overlay-element");
        if (existingOverlay) {
          container.removeChild(existingOverlay);
        }
      }
    };
    t2 = [isChannelInfoOpen];
    $[2] = isChannelInfoOpen;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== popModal || $[6] !== pushModal) {
    t3 = error => {
      if (error instanceof BaseHttpResponseError) {
        pushModal({
          type: MODAL_TYPE_PC.CONFIRM_MODAL,
          id: "ChannelHeader - 1",
          options: {
            description: error.message,
            onClose: popModal
          }
        });
        return;
      }
      pushModal({
        type: MODAL_TYPE_PC.CONFIRM_MODAL,
        id: "ChannelHeader - 2",
        options: {
          description: "\uC54C\uC218\uC5C6\uB294 \uC624\uB958\uB85C \uC694\uCCAD\uC774 \uC2E4\uD328\uD558\uC600\uC2B5\uB2C8\uB2E4."
        }
      });
    };
    $[5] = popModal;
    $[6] = pushModal;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleBookmarkError = t3;
  let t4;
  if ($[8] !== bjInfoData || $[9] !== pushModal || $[10] !== refetchBjInfo) {
    t4 = () => {
      pushModal({
        type: MODAL_TYPE_PC.CHANNEL_EDIT_MODAL,
        id: "ChannelHeader - 3",
        options: {
          bjInfoData,
          onEdit: () => {
            refetchBjInfo();
          }
        }
      });
    };
    $[8] = bjInfoData;
    $[9] = pushModal;
    $[10] = refetchBjInfo;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const showChannelEditModal = t4;
  let t5;
  if ($[12] !== pushModal) {
    t5 = () => {
      if (aspCond.if("new-asp")) {
        SettingConfig.aspUtils?.goLogin();
        return;
      }
      pushModal({
        id: "ChannelHeader - 5",
        type: MODAL_TYPE_PC.AUTH_MODAL
      });
    };
    $[12] = pushModal;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const popupLogin = t5;
  let t6;
  if ($[14] !== bjInfoData || $[15] !== isLogin || $[16] !== popupLogin || $[17] !== pushModal || $[18] !== userInfo?.authYN) {
    t6 = () => {
      if (userInfo?.authYN === "N") {
        pushModal({
          id: "ChannelHeader - 4",
          type: MODAL_TYPE_PC.IDENTITY_VERIFICATION_MODAL
        });
        return;
      }
      if (!isLogin) {
        popupLogin();
        return;
      }
      if (!bjInfoData) {
        return;
      }
      pushModal({
        id: "ChannelHeader - 6",
        type: MODAL_TYPE_PC.SEND_MESSAGE_MODAL,
        options: {
          userIdx: bjInfoData.bjInfo.idx,
          userId: bjInfoData.bjInfo.id,
          userNick: bjInfoData.bjInfo.nick,
          idMasking: false
        }
      });
    };
    $[14] = bjInfoData;
    $[15] = isLogin;
    $[16] = popupLogin;
    $[17] = pushModal;
    $[18] = userInfo?.authYN;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const showSendMessageModal = t6;
  let t7;
  if ($[20] !== bjInfoData || $[21] !== isLogin || $[22] !== popupLogin || $[23] !== pushModal) {
    t7 = () => {
      if (!isLogin) {
        popupLogin();
        return;
      }
      if (!bjInfoData) {
        return;
      }
      pushModal({
        id: "ChannelHeader - 8",
        type: MODAL_TYPE_PC.GIFT_HEART_MODAL,
        options: {
          userId: bjInfoData.bjInfo.id,
          userNick: bjInfoData.bjInfo.nick,
          userIdx: bjInfoData.bjInfo.idx
        }
      });
    };
    $[20] = bjInfoData;
    $[21] = isLogin;
    $[22] = popupLogin;
    $[23] = pushModal;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  const showGiftHeartModal = t7;
  let t8;
  if ($[25] !== bjInfoData || $[26] !== isLogin || $[27] !== popupLogin) {
    t8 = () => {
      if (!isLogin) {
        popupLogin();
        return;
      }
      if (!bjInfoData) {
        return;
      }
      setIsMissionModalOpen(true);
    };
    $[25] = bjInfoData;
    $[26] = isLogin;
    $[27] = popupLogin;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  const showMissionChallengeModal = t8;
  let t9;
  if ($[29] !== bjInfoData || $[30] !== goPlay) {
    t9 = () => {
      if (!bjInfoData || !bjInfoData.media?.isLive) {
        return;
      }
      if (bjInfoData?.media) {
        goPlay(bjInfoData.media);
      }
    };
    $[29] = bjInfoData;
    $[30] = goPlay;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  const handleProfileImageClick = t9;
  bjInfoData?.bjInfo.channelBannerUrl;
  bjInfoData?.bjInfo.thumbUrl;
  let t10;
  bb0: {
    const bannerUrl = bjInfoData?.bjInfo.channelBannerUrl;
    if (bannerUrl) {
      t10 = `url(${bannerUrl})`;
      break bb0;
    }
    t10 = isBlockedService ? "none" : `url(${bjInfoData?.bjInfo.thumbUrl})`;
  }
  const bannerUrl_0 = t10;
  if (!bjInfoData) {
    let t11;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div className="px-10"><Skeleton className="mx-auto h-[296px] w-[1280px] rounded-[20px] bg-slate-300" /></div>;
      $[32] = t11;
    } else {
      t11 = $[32];
    }
    return t11;
  }
  let t11;
  if ($[33] !== bannerUrl_0) {
    t11 = {
      backgroundImage: bannerUrl_0,
      backgroundPosition: "center 20%"
    };
    $[33] = bannerUrl_0;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== isBlockedService) {
    t12 = !isBlockedService && <div className="absolute inset-0 rounded-[20px] bg-black opacity-30" />;
    $[35] = isBlockedService;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== channelId || $[38] !== isMyChannel || $[39] !== userInfo) {
    t13 = isMyChannel && userInfo.isBJ === "Y" && <Link prefetch={false} href={`/channel/${channelId}/bjNotice`} className="mr-8 flex items-center"><IcoChannelNotice style={{
        fontSize: 24
      }} /></Link>;
    $[37] = channelId;
    $[38] = isMyChannel;
    $[39] = userInfo;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== bjInfoData.bjInfo.idx || $[42] !== bjInfoData.isBookmark || $[43] !== bjInfoData.runningMission || $[44] !== handleBookmarkError || $[45] !== isBlockedService || $[46] !== isMyChannel || $[47] !== isPostAvailable || $[48] !== showGiftHeartModal || $[49] !== showMissionChallengeModal || $[50] !== showSendMessageModal) {
    t14 = !isMyChannel && !isBlockedService && <><div className="mr-8"><BookmarkButton initIsBookmark={!!bjInfoData.isBookmark} userIndex={bjInfoData.bjInfo.idx} fetchErrorCallback={handleBookmarkError} variant="channel" width={28} isTooltip={false} /></div>{isPostAvailable && <button type="button" className="mr-8" onClick={showSendMessageModal}><img alt="letter" src={`${SettingConfig.S3_BUCKET_URL}/img/icon/letter_white.svg`} width={28} height={28} /></button>}<button type="button" className="mr-8" onClick={showGiftHeartModal}><img alt="gift" src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_gift_white.svg`} width={28} height={28} /></button><button className={cn("relative mr-8", {
        "after:-right-1.5 after:-top-1.5 after:absolute after:h-2 after:w-2 after:rounded-full after:bg-[#fe695d]": bjInfoData.runningMission
      })} onClick={showMissionChallengeModal}><MissionIconWhite /></button></>;
    $[41] = bjInfoData.bjInfo.idx;
    $[42] = bjInfoData.isBookmark;
    $[43] = bjInfoData.runningMission;
    $[44] = handleBookmarkError;
    $[45] = isBlockedService;
    $[46] = isMyChannel;
    $[47] = isPostAvailable;
    $[48] = showGiftHeartModal;
    $[49] = showMissionChallengeModal;
    $[50] = showSendMessageModal;
    $[51] = t14;
  } else {
    t14 = $[51];
  }
  let t15;
  if ($[52] !== bjInfoData.bjInfo.fanCnt || $[53] !== bjInfoData.bjInfo.playTime || $[54] !== bjInfoData.bjInfo.rank || $[55] !== bjInfoData.bjInfo.scoreBookmark || $[56] !== bjInfoData.bjInfo.scoreLike || $[57] !== bjInfoData.bjInfo.scoreTotal || $[58] !== bjInfoData.bjInfo.scoreWatch || $[59] !== isBlockedService || $[60] !== isChannelInfoOpen) {
    t15 = !isBlockedService && <div className="relative"><button className="flex h-full items-center" onClick={() => setIsChannelInfoOpen(!isChannelInfoOpen)}><BaseSVG src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_info_white.svg`} width={28} height={28} /></button>{isChannelInfoOpen && <><div className="fixed top-0 right-0 bottom-0 left-0 z-40 bg-black/50" /><div className="-left-[260px] absolute top-10 z-50 w-[300px] rounded-2xl bg-colorBg02 px-[24px] pt-[21px] pb-[24px]"><div className="mb-5 flex items-center justify-between font-bold text-[20px] text-colorFg01">채널정보<button onClick={() => setIsChannelInfoOpen(false)}><IcoClose style={{
                fontSize: 11,
                color: "var(--baseFg)"
              }} /></button></div><div className="leading-[42px]"><div className="flex w-full justify-between text-[16px] text-colorFg02"><span>BJ 점수</span><span className="font-[500]">{`${formatNumberWithComma(bjInfoData.bjInfo.scoreTotal)} 점`}</span></div></div>{!!bjInfoData.bjInfo.rank && <div className="leading-[42px]"><div className="flex w-full justify-between text-[16px] text-colorFg02"><span>BJ 랭킹</span><span className="font-[500]">{`${formatNumberWithComma(bjInfoData.bjInfo.rank)} 위`}</span></div></div>}<div className="leading-[42px]"><div className="flex w-full justify-between text-[16px] text-colorFg02"><span>시청자 점수</span><span className="font-[500]">{`${formatNumberWithComma(bjInfoData.bjInfo.scoreWatch)} 점`}</span></div></div><div className="leading-[42px]"><div className="flex w-full justify-between text-[16px] text-colorFg02"><span>방송 팬</span><span className="font-[500]">{`${formatNumberWithComma(bjInfoData.bjInfo.fanCnt)} 명`}</span></div></div><div className="leading-[42px]"><div className="flex w-full justify-between text-[16px] text-colorFg02"><span>추천 수</span><span className="font-[500]">{`${formatNumberWithComma(bjInfoData.bjInfo.scoreLike)} 명`}</span></div></div><div className="leading-[42px]"><div className="flex w-full justify-between text-[16px] text-colorFg02"><span>북마크</span><span className="font-[500]">{`${formatNumberWithComma(bjInfoData.bjInfo.scoreBookmark)} 명`}</span></div></div><div className="leading-[42px]"><div className="flex w-full justify-between text-[16px] text-colorFg02"><span>총 방송시간</span><span className="font-[500]">{bjInfoData.bjInfo.playTime.total}</span></div></div></div></>}</div>;
    $[52] = bjInfoData.bjInfo.fanCnt;
    $[53] = bjInfoData.bjInfo.playTime;
    $[54] = bjInfoData.bjInfo.rank;
    $[55] = bjInfoData.bjInfo.scoreBookmark;
    $[56] = bjInfoData.bjInfo.scoreLike;
    $[57] = bjInfoData.bjInfo.scoreTotal;
    $[58] = bjInfoData.bjInfo.scoreWatch;
    $[59] = isBlockedService;
    $[60] = isChannelInfoOpen;
    $[61] = t15;
  } else {
    t15 = $[61];
  }
  let t16;
  if ($[62] !== t13 || $[63] !== t14 || $[64] !== t15) {
    t16 = <div className="flex w-full justify-end">{t13}{t14}{t15}</div>;
    $[62] = t13;
    $[63] = t14;
    $[64] = t15;
    $[65] = t16;
  } else {
    t16 = $[65];
  }
  let t17;
  if ($[66] !== bjInfoData.media?.isLive) {
    t17 = bjInfoData.media?.isLive && <div className="absolute top-[50%] left-[50%] h-[72px] w-[72px] translate-x-[-50%] translate-y-[-50%] overflow-hidden rounded-full"><img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/profile_live_edge.png`} alt="live" className="absolute top-[50%] left-[50%] h-full w-full translate-x-[-50%] translate-y-[-50%] object-cover" width={72} height={72} /></div>;
    $[66] = bjInfoData.media?.isLive;
    $[67] = t17;
  } else {
    t17 = $[67];
  }
  let t18;
  if ($[68] !== bjInfoData.bjInfo.thumbUrl || $[69] !== isBlockedService) {
    t18 = !isBlockedService && <div className="h-[72px] w-[72px] overflow-hidden rounded-full"><img src={bjInfoData?.bjInfo.thumbUrl} alt="profileimg" className="h-full w-full object-cover" /></div>;
    $[68] = bjInfoData.bjInfo.thumbUrl;
    $[69] = isBlockedService;
    $[70] = t18;
  } else {
    t18 = $[70];
  }
  let t19;
  if ($[71] !== isBlockedService) {
    t19 = isBlockedService && <IcoProfileBan style={{
      fontSize: 72
    }} />;
    $[71] = isBlockedService;
    $[72] = t19;
  } else {
    t19 = $[72];
  }
  let t20;
  if ($[73] !== bjInfoData.bjInfo.rank || $[74] !== isTopRank) {
    t20 = isTopRank && <div className="absolute right-0 bottom-0"><img width={22} src={`${SettingConfig.S3_BUCKET_URL}/img/rank/ico_ranking_0${bjInfoData.bjInfo.rank}.png`} alt={`${bjInfoData.bjInfo.rank}`} /></div>;
    $[73] = bjInfoData.bjInfo.rank;
    $[74] = isTopRank;
    $[75] = t20;
  } else {
    t20 = $[75];
  }
  let t21;
  if ($[76] !== bjInfoData.bjInfo.bjAnni) {
    t21 = !!bjInfoData.bjInfo.bjAnni && <><BaseLottie src={`${SettingConfig.S3_BUCKET_URL}/json/lottie/memory/memory_icon.json`} loop={true} className="-top-4 absolute left-[34px] z-[1] h-[56px] w-[57px]" /><BaseLottie src={`${SettingConfig.S3_BUCKET_URL}/json/lottie/memory/memory_squib.json`} loop={true} className="-right-[44px] -top-14 absolute z-[1] h-[120px] w-[160px]" /></>;
    $[76] = bjInfoData.bjInfo.bjAnni;
    $[77] = t21;
  } else {
    t21 = $[77];
  }
  let t22;
  if ($[78] !== handleProfileImageClick || $[79] !== t17 || $[80] !== t18 || $[81] !== t19 || $[82] !== t20 || $[83] !== t21) {
    t22 = <button className="relative" onClick={handleProfileImageClick}>{t17}{t18}{t19}{t20}{t21}</button>;
    $[78] = handleProfileImageClick;
    $[79] = t17;
    $[80] = t18;
    $[81] = t19;
    $[82] = t20;
    $[83] = t21;
    $[84] = t22;
  } else {
    t22 = $[84];
  }
  let t23;
  if ($[85] !== bjInfoData.bjInfo.channelTitle) {
    t23 = <span className="font-[500] text-[34px] text-white">{bjInfoData.bjInfo.channelTitle}</span>;
    $[85] = bjInfoData.bjInfo.channelTitle;
    $[86] = t23;
  } else {
    t23 = $[86];
  }
  let t24;
  if ($[87] !== channelId || $[88] !== isMyChannel || $[89] !== showChannelEditModal || $[90] !== showGlobalNoticeBanner || $[91] !== userInfo?.globalBJYN) {
    t24 = isMyChannel && <><button className="ml-4" onClick={() => showChannelEditModal()}><img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_pencil_white.png`} alt="modify" width={28} height={28} /></button>{userInfo?.globalBJYN === "Y" && showGlobalNoticeBanner && <GlobalServiceNoticeBanner channelId={channelId} />}</>;
    $[87] = channelId;
    $[88] = isMyChannel;
    $[89] = showChannelEditModal;
    $[90] = showGlobalNoticeBanner;
    $[91] = userInfo?.globalBJYN;
    $[92] = t24;
  } else {
    t24 = $[92];
  }
  let t25;
  if ($[93] !== t23 || $[94] !== t24) {
    t25 = <p className="relative flex items-center">{t23}{t24}</p>;
    $[93] = t23;
    $[94] = t24;
    $[95] = t25;
  } else {
    t25 = $[95];
  }
  let t26;
  if ($[96] !== bjInfoData.bjInfo.vipDeco) {
    t26 = <VipDecoBadge vipDecoCode={bjInfoData.bjInfo.vipDeco} className="mr-1" />;
    $[96] = bjInfoData.bjInfo.vipDeco;
    $[97] = t26;
  } else {
    t26 = $[97];
  }
  let t27;
  if ($[98] !== bjInfoData.bjInfo.globalYN) {
    t27 = !SettingConfig.isProd && bjInfoData?.bjInfo.globalYN === "Y" && <BaseSVG src={`${SettingConfig.S3_BUCKET_URL}/img/vipDeco/ico_global_tag.svg`} width={60} height={15} className="mr-[6px]" />;
    $[98] = bjInfoData.bjInfo.globalYN;
    $[99] = t27;
  } else {
    t27 = $[99];
  }
  let t28;
  if ($[100] !== bjInfoData.bjInfo.rank) {
    t28 = !!bjInfoData.bjInfo.rank && <><span>{`BJ랭킹 ${`${bjInfoData.bjInfo.rank}위`}`}</span><span className="mx-1">·</span></>;
    $[100] = bjInfoData.bjInfo.rank;
    $[101] = t28;
  } else {
    t28 = $[101];
  }
  const t29 = `${bjInfoData.bjInfo.nick}(${bjInfoData.bjInfo.id})`;
  let t30;
  if ($[102] !== t29) {
    t30 = <span>{t29}</span>;
    $[102] = t29;
    $[103] = t30;
  } else {
    t30 = $[103];
  }
  let t31;
  if ($[104] !== t26 || $[105] !== t27 || $[106] !== t28 || $[107] !== t30) {
    t31 = <p className="flex items-center text-[#ffffffb2]">{t26}{t27}{t28}{t30}</p>;
    $[104] = t26;
    $[105] = t27;
    $[106] = t28;
    $[107] = t30;
    $[108] = t31;
  } else {
    t31 = $[108];
  }
  let t32;
  if ($[109] !== t25 || $[110] !== t31) {
    t32 = <div className="ml-6 flex h-16 flex-col justify-between">{t25}{t31}</div>;
    $[109] = t25;
    $[110] = t31;
    $[111] = t32;
  } else {
    t32 = $[111];
  }
  let t33;
  if ($[112] !== t22 || $[113] !== t32) {
    t33 = <div className="flex">{t22}{t32}</div>;
    $[112] = t22;
    $[113] = t32;
    $[114] = t33;
  } else {
    t33 = $[114];
  }
  let t34;
  if ($[115] !== t16 || $[116] !== t33) {
    t34 = <div className="relative z-10 flex h-full flex-col justify-between px-10 pt-10 pb-10">{t16}{t33}</div>;
    $[115] = t16;
    $[116] = t33;
    $[117] = t34;
  } else {
    t34 = $[117];
  }
  let t35;
  if ($[118] !== t11 || $[119] !== t12 || $[120] !== t34) {
    t35 = <div className="relative mx-auto h-[296px] w-[1280px] rounded-[20px] border border-borderBg03 bg-[#0000004D] bg-cover bg-no-repeat" style={t11}>{t12}{t34}</div>;
    $[118] = t11;
    $[119] = t12;
    $[120] = t34;
    $[121] = t35;
  } else {
    t35 = $[121];
  }
  let t36;
  if ($[122] !== bjInfoData.bjInfo.idx || $[123] !== isMissionModalOpen) {
    t36 = isMissionModalOpen && <ModalMissionChallenge userIdx={bjInfoData.bjInfo.idx} setOpen={setIsMissionModalOpen} />;
    $[122] = bjInfoData.bjInfo.idx;
    $[123] = isMissionModalOpen;
    $[124] = t36;
  } else {
    t36 = $[124];
  }
  let t37;
  if ($[125] !== t35 || $[126] !== t36) {
    t37 = <><div className="px-10" data-testid="channel-profile">{t35}{t36}</div></>;
    $[125] = t35;
    $[126] = t36;
    $[127] = t37;
  } else {
    t37 = $[127];
  }
  return t37;
}
export default ChannelHeader;